import Vue from 'vue'
import NProgress from 'nprogress'
import Router from 'vue-router'
import $store from '@/js/vuex/store'
Vue.use(Router);
const router = new Router({
  mode:'history',
  routes: [
    {name: 'index', path: '', redirect: '/front/learn', hidden: true},//空地址重定向到登录页面
    {name: 'login', path: '/login', component: (resolve) => require(['@/pages/admin/module/login/login.vue'], resolve),},
    {name: '404', path: '/404', component: (resolve) => require(['@/pages/admin/sys/error/404.vue'], resolve),},
    {
      name: 'main', path: '/main', meta: {title: "主页"}, component: (resolve) => require(['@/pages/admin/sys/home/main.vue'], resolve),
      children: [
        {name: "home", path: '/home', meta: {title: "平台首页"},  component: (resolve) => require(['@/pages/admin/sys/home/home.vue'], resolve),},
        {name: 'notFound', path: '*',  redirect: '/',  hidden: true}/*页面不存在的情况下会跳到404页面*/
      ]
    },
    //front路由
    {meta: {title: "网站主页"}, name: 'frontIndex', path: '/front/learn', component: (resolve) => require(['@/pages/front/index/index.vue'], resolve),
      children: [
        {meta: {title: "网站首页"}, name: 'frontHome', path: '/front/home', component: (resolve) => require(['@/pages/front/service/home/home.vue'], resolve)},
        {meta: {title: "软件中心"}, name: 'software', path: '/front/software', component: (resolve) => require(['@/pages/front/service/item/software.vue'], resolve)},
        {meta: {title: "备用软件"}, name: 'software2', path: '/front/software2', component: (resolve) => require(['@/pages/front/service/item/software2.vue'], resolve)},
        {meta: {title: "毕设指导"}, name: 'course', path: '/front/course', component: (resolve) => require(['@/pages/front/service/item/course.vue'], resolve)},
        {meta: {title: "答辩百科"}, name: 'search', path: '/front/search', component: (resolve) => require(['@/pages/front/service/item/search.vue'], resolve)},
        {meta: {title: "作品展示"}, name: 'works', path: '/front/works', component: (resolve) => require(['@/pages/front/service/item/works.vue'], resolve)},
        {meta: {title: "作品详情"}, name: 'worksDetails', path: '/front/worksDetails', component: (resolve) => require(['@/pages/front/service/works/worksDetails.vue'], resolve)},
        {meta: {title: "联系我们"}, name: 'about', path: '/front/about', component: (resolve) => require(['@/pages/front/service/item/about.vue'], resolve)},
      ]
    },
  ]
});

//将获取到的用户菜单数据转换成路由
function generateRoutes(accessRoutes) {
  let routers = router.options['routes'];
  routers.forEach(item => {
    if (item.name === 'main') {
      let userRoutes = accessRoutes.map(item => {
        return {
          name: item.name,
          path: item.path,
          meta: {title: item.title},
          component: (resolve) => require(["@/pages/" + item.component], resolve),
        }
      });
      item.children.push(...userRoutes);
      console.log("userRoutes", userRoutes);
      routers.push({path: '*', redirect: '/404', hidden: true})
      router.addRoutes(routers);//重新覆盖,避免叠加
      console.log("allRoutes", routers);
    }
  })
}

//路由拦截守卫
router.beforeEach((to, from, next) => {
  console.log("to:", to);
  NProgress.start();
  /**************************************** admin端 ****************************************/
  if (to.path.indexOf('/front') < 0) {
    if (to.path != "/login") {
      if ($store.getters.routes.length == 0) {//有没配置信息
        $store.dispatch('commitConfig');
        $store.dispatch('commitDictList');
        $store.dispatch('commitAdminLoginInfo').then(res => {
          if ($store.getters.hasLogin) {//如果有登录加载路由。
            $store.dispatch('commitUserRoutes').then(res => {
              let accessRoutes = res.list;
              generateRoutes(accessRoutes);
              next({...to, replace: true}) // hack方法 确保addRoutes已完成
            }).catch(err => {
              console.log("err:", to)
              $store.dispatch('commitLoginOut').then(() => {
                next({path: '/login'})
                NProgress.done();
              })
            })
          } else {//如果有登录跳转登录页面。
            $store.dispatch('commitLoginOut').then(() => {
              next({path: '/login'});
              NProgress.done();
            });
          }
        });
      } else {//路由加载过放行
        next();
        NProgress.done();
      }
    } else {
      $store.dispatch('commitAdminLoginInfo').then(res => {
        if ($store.getters.hasLogin) {//如果有登录加载路由。
          next({path: '/main/home'});
          NProgress.done();
        } else {
          next();
          NProgress.done();
        }
      });
    }
  }
  /**************************************** front端 ****************************************/
  if (to.path.indexOf('/front') >= 0) {
    if ($store.getters.dictList.length == 0) {//如果没有配置信息
      $store.dispatch('commitConfig');//复制页面地址重新加载配置
      $store.dispatch('commitDictList');
      if (sessionStorage.getItem("token")) {//有登录
        $store.dispatch('commitFrontLoginInfo');
      } else {
        //$store.dispatch('commitFrontLoginOut')
      }
    }
    next();
    NProgress.done();
  }
});

router.afterEach(() => {
  document.title = "欢迎登录";
  if ($store.getters.config.projectName) {
    document.title = $store.getters.config.projectName;
  }
  NProgress.done();
});
export default router



// WEBPACK FOOTER //
// ./src/js/router/index.js